export default function Sidebar() {
    return (
        <div class="mx-5 my-8">
            <a href="/learn/one">
                <p class="transition-all ease-in-out font-avenir font-bold text-sm text-frcblue leading-none hover:text-frcpurple duration-300">CHAPTER 1</p>
                <p class="transision-all ease-in-out font-scoutcond font-bold text-4xl text-black hover:text-frcblue duration-300 leading-none">FRC BASICS</p>
            </a>
            <div class="border-l-2 border-frcblue ml-2 mt-2">
                <ul class="font-productsans font-bold ml-3">
                    <li>
                        <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/one/a">What is FRC?</a>
                    </li>
                    <li>
                        <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/one/b">Prior Experience</a>
                    </li>
                    <li>
                        <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/one/c">What does FRC do?</a>
                    </li>
                </ul>
            </div>
            <a href="/learn/two">
                <p class="mt-5 transition-all ease-in-out font-avenir font-bold text-sm text-frcblue leading-none hover:text-frcpurple duration-300">CHAPTER 2</p>
                <p class="transision-all ease-in-out font-scoutcond font-bold text-4xl text-black hover:text-frcblue duration-300 leading-none">STRATEGY GUIDE</p>
            </a>
            <div class="border-l-2 border-frcblue ml-2 mt-2">
                <ul class="font-productsans font-bold ml-3">
                    <li>
                        <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/two/a">Key Tenets of FRC Strategy</a>
                    </li>
                    <li>
                        <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/two/b">Past Game Analysis</a>
                    </li>
                </ul>
            </div>
            <a href="/learn/three">
                <p class="mt-5 transition-all ease-in-out font-avenir font-bold text-sm text-frcblue leading-none hover:text-frcpurple duration-300">CHAPTER 3</p>
                <p class="transision-all ease-in-out font-scoutcond font-bold text-4xl text-black hover:text-frcblue duration-300 leading-none">INTRO TO ONSHAPE</p>
            </a>
            <div class="border-l-2 border-frcblue ml-2 mt-2">
                <ul class="font-productsans font-bold ml-3">
                    <li>
                        <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/three/a">What is Onshape?</a>
                    </li>
                    <li>
                        <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/three/b">Setting up Onshape</a>
                    </li>
                    <li>
                        <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/three/c">Introduction to Sketching</a>
                    </li>
                    <li>
                        <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/three/d">Constraints</a>
                    </li>
                    <li>
                        <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/three/e">Introduction to Extrudes</a>
                    </li>
                    <li>
                        <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/three/f">Introduction to Assemblies</a>
                    </li>
                </ul>
            </div>
            <a href="/learn/four">
                <p class="mt-5 transition-all ease-in-out font-avenir font-bold text-sm text-frcblue leading-none hover:text-frcpurple duration-300">CHAPTER 4</p>
                <p class="transision-all ease-in-out font-scoutcond font-bold text-4xl text-black hover:text-frcblue duration-300 leading-none">MECHANICAL BASICS</p>
            </a>
            <div class="border-l-2 border-frcblue ml-2 mt-2">
                <ul class="font-productsans font-bold ml-3">
                    <li>
                        <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/four/a">Tools and Machinery</a>
                    </li>
                    <li>
                        <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/four/b">Tool Size Guide</a>
                    </li>
                    <li>
                        <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/four/c">Gears, Chains, and Belts</a>
                    </li>
                    <li>
                        <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/four/d">Motors</a>
                    </li>
                    <li>
                        <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/four/e">Drivetrains</a>
                    </li>
                </ul>
            </div>
            <a href="/learn/five">
                <p class="mt-5 transition-all ease-in-out font-avenir font-bold text-sm text-frcblue leading-none hover:text-frcpurple duration-300">CHAPTER 5</p>
                <p class="transision-all ease-in-out font-scoutcond font-bold text-4xl text-black hover:text-frcblue duration-300 leading-none">CADDING FOR FRC</p>
            </a>
            <div class="border-l-2 border-frcblue ml-2 mt-2">
                <ul class="font-productsans font-bold ml-3">
                    <li>
                        <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/five/a">Onshape Featurescripts and Preexisting Libraries</a>
                    </li>
                    <li>
                        <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/five/b">FRC Design Calculator</a>
                    </li>
                    <li>
                        <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/five/c">Guided Gearbox Demonstration</a>
                    </li>
                </ul>
            </div>
        </div>
    )
}